import { site } from "@/data/site";
import { Reveal } from "./Reveal";

export const BrandPhilosophy = () => {
    return (
        <section
            id="philosophy"
            data-testid="philosophy-section"
            className="bg-ivory px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-14 flex flex-col items-center text-center lg:mb-20">
                        <span className="eyebrow">Our Philosophy</span>
                        <h2 className="mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-charcoal sm:text-5xl">
                            A relationship, not a transaction.
                        </h2>
                    </div>
                </Reveal>

                <div className="grid gap-6 md:grid-cols-3 lg:gap-8">
                    {site.philosophy.map((p, i) => (
                        <Reveal key={p.word} delay={i * 0.12}>
                            <div className="group h-full border border-line bg-sand p-9 transition-all duration-500 hover:-translate-y-1 hover:border-champagne hover:shadow-[0_24px_60px_rgba(43,43,43,0.08)] lg:p-11">
                                <span className="font-serif text-2xl italic text-orange">
                                    {p.word}
                                </span>
                                <div className="my-6 h-px w-12 bg-champagne transition-all duration-500 group-hover:w-20" />
                                <h3 className="font-serif text-2xl leading-snug text-charcoal">
                                    {p.title}
                                </h3>
                                <p className="mt-5 text-base leading-relaxed text-slatey">
                                    {p.body}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
